interface Props {
  readonly condition: unknown;
  readonly children: any;
}

export function Condition(props: Props | any) {
  if (!props.condition) return null;

  return <>{props.children}</>;
}
